export default class MvBg {
    constructor(controller) {
        this.controller = controller;
        this.init();
    }

    init() {
        this.mvBg();
    }

    mvBg() {
        const typeTxts = document.querySelectorAll('.js-txt-split');

        typeTxts.forEach((el) => {
            const textContent = el.textContent;

            const newTextContent = [...textContent].map((char) => `<div class="mv__bg__txt__letter js-type-letter">${char}</div>`).join('');

            el.innerHTML = newTextContent;
        });

        const typeLetter = document.querySelectorAll('.js-type-letter');

        const typeTL = gsap.timeline({repeat : -1});
        typeTL.to(
            typeLetter,
            {
                autoAlpha: 0,
            },
            '+=1'
        )
        .to(
            typeLetter,
            {
                autoAlpha: 1,
                ease: "power3.inOut",
                stagger: {
                    each: 0.25,
                },
            },
            '+=1'
        ).to(
            typeLetter,
            {
                autoAlpha: 0,
                ease: 'back.out(2.5)',
                stagger: {
                    each: 0.1,
                    from:'end',
                },
            },
            '+=2.5'
        );
            
    }
}
